import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import { Button, Alert, Typography } from '@weave-mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/apiClient';
import { queryKeys } from '../query/queryClient';
const MAX_LENGTH = 500;
const DialogBody = ({ onClose, batchId, currentDescription }) => {
    const queryClient = useQueryClient();
    const [value, setValue] = useState(currentDescription ?? '');
    const [error, setError] = useState(null);
    const mutation = useMutation({
        mutationFn: (description) => api.batches.updateDescription(batchId, description),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: queryKeys.batches.detail(batchId) });
            onClose();
        },
        onError: (err) => {
            setError(err?.message ?? 'Failed to update description');
        },
    });
    const handleSave = () => {
        setError(null);
        const trimmed = value.trim();
        mutation.mutate(trimmed === '' ? null : trimmed);
    };
    return (_jsxs(_Fragment, { children: [_jsx(DialogTitle, { children: "Edit Description" }), _jsxs(DialogContent, { children: [_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: 'Document plans for this batch (e.g. "Waiting for next DB rename window", "Planned for prod validation 2026-04-01").' }), error && (_jsx(Alert, { severity: "error", sx: { mb: 2 }, children: error })), _jsx(TextField, { autoFocus: true, multiline: true, rows: 4, fullWidth: true, label: "Description", value: value, onChange: (e) => setValue(e.target.value), inputProps: { maxLength: MAX_LENGTH }, helperText: `${value.length} / ${MAX_LENGTH}`, disabled: mutation.isPending })] }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, disabled: mutation.isPending, children: "Cancel" }), _jsx(Button, { variant: "contained", onClick: handleSave, disabled: mutation.isPending, children: mutation.isPending ? 'Saving…' : 'Save' })] })] }));
};
const EditDescriptionDialog = ({ open, onClose, batchId, currentDescription, }) => {
    return (_jsx(Dialog, { open: open, onClose: onClose, maxWidth: "sm", fullWidth: true, children: open && (_jsx(DialogBody, { onClose: onClose, batchId: batchId, currentDescription: currentDescription }, batchId)) }));
};
export default EditDescriptionDialog;
